import { render, staticRenderFns } from "./autocomplete--taxonomy.vue?vue&type=template&id=bb1f4db6&scoped=true&"
import script from "./autocomplete--taxonomy.vue?vue&type=script&lang=js&"
export * from "./autocomplete--taxonomy.vue?vue&type=script&lang=js&"
import style0 from "./autocomplete--taxonomy.vue?vue&type=style&index=0&id=bb1f4db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f4db6",
  null
  
)

export default component.exports